"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonClone = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const SimpleButton_1 = tslib_1.__importDefault(require("../../../components/SimpleButton"));
const ButtonClone = (props) => {
    return (React.createElement(SimpleButton_1.default, Object.assign({ "data-name": "clone", tooltip: "Clone", tone: "accent", icon: "clone", variant: "raised" }, props), props.children === undefined ? 'Clone' : props.children));
};
exports.ButtonClone = ButtonClone;
